exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#purchase-costs[data-v-e01e33d4]{overflow:visible}.purchase-costs-header[data-v-e01e33d4]{margin-bottom:30px}.purchase-price[data-v-e01e33d4]{display:block!important}.deposit-source[data-v-e01e33d4]{overflow:visible!important}@media not print{@media (min-width:1024px){.calc-col-one[data-v-e01e33d4]{width:50%;float:left}.calc-col-two[data-v-e01e33d4]{width:50%;float:right}.purchase-price[data-v-e01e33d4]{display:flex!important}.purchase-price-require-info[data-v-e01e33d4]{margin-top:-30px!important}.property-suburb-require-info[data-v-e01e33d4]{margin-top:-32px!important}}}@media (max-width:1023px){.bottom-margin-0[data-v-e01e33d4]{margin-bottom:0!important}}@media (max-width:328px){.legal-fees[data-v-e01e33d4]{margin-bottom:30px!important}.extra-bottom-margin-width-max-328[data-v-e01e33d4]{margin-bottom:60px!important}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e01e33d4","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Components/PurchaseCosts.vue
// module id = 67
// module chunks = 0